"use client";

import { Icon, deviceDetector, ospThemes } from "@ospweb/sdk-ui";
import { AppImage } from "@/src/components/NextImage";
import { ShellLink } from "@/src/components";
import { cn } from "utils";
import { useSnapshot } from "valtio";
import { useState } from "react";
import { MenuModal } from "../Menu";
import { MenuSearchModalCreateAble } from "../Menu/MenuSearchModal";
import { stickyConfig } from "../stickyConfig";
import { Back } from "./Back";
import { HomeStore, rootStore } from "@/src/store";

import { I18nUtil } from "@utils/i18n";
import { ROUTER_PATH } from "@/src/config";
import Translations from "@translate/components/mainHeader/MainHeader";

interface BasicMainHeaderProps {
  showSearch?: boolean;
  isBack?: boolean;
  mainTitle?: string;
  headerTitle?: string;
  titleClassName?: string;
  className?: string;
  slotContainerclassName?: string;
  rightChildren?: React.ReactNode;
  leftChildren?: React.ReactNode;
  showMenuButton?: boolean;
  goBack?: () => void;
  isGoHome?: boolean;
}

const I18n = I18nUtil.createScoped(Translations);

const BasicMainHeader = ({
  showSearch = false,
  isBack = true,
  goBack,
  mainTitle = "",
  headerTitle = "",
  titleClassName = "",
  rightChildren,
  leftChildren,
  className,
  slotContainerclassName,
  showMenuButton = true,
  isGoHome = false,
}: BasicMainHeaderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { type } = useSnapshot(rootStore.app);
  const onCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div
        className={cn(
          "flex flex-1 w-full items-center h-13 justify-between absolute md:sticky top-0 bg-background_solid_secondary z-11 py-2 px-4 md:rounded-tr-2xl md:rounded-tl-2xl rounded-t-0 z-200",
          type === "extension" && "bg-background_solid_secondary",
          className,
        )}
        style={{
          minHeight: stickyConfig.headerHeight,
        }}
        id="header"
      >
        {!!leftChildren ? (
          leftChildren
        ) : (
          <div className="flex items-center gap-1">
            {!isBack ? (
              <div className="flex items-center gap-1">
                <ShellLink
                  aria-label="Main Header"
                  data-openreplay-label={`Main Header Link | ${ROUTER_PATH.HOME}`}
                  id="lnk-main-header"
                  href={ROUTER_PATH.HOME}
                  className="cursor-pointer flex items-center gap-1"
                >
                  <AppImage
                    width={98}
                    height={28}
                    alt="edgen-logo"
                    className={`md:hidden min-w-[98px]`}
                    src={"/assets/images/logo.svg"}
                  />
                </ShellLink>
                <span className="text-content_primary body_medium_l">
                  {mainTitle}
                </span>
              </div>
            ) : (
              <Back
                title={headerTitle}
                goBack={goBack}
                isGoHome={isGoHome}
                titleClassName={titleClassName}
              />
            )}
          </div>
        )}

        {showSearch && (
          <div
            data-openreplay-label="mainHeader · MainHeader · div"
            onClick={async () => {
              await MenuSearchModalCreateAble({
                type: "normal",
              });
              onCancel?.();
            }}
            className="w-[50%] bg-background_white_overlay5 rounded-2 border-background_white_overlay5 hover:border-background_white_overlay10 border-solid border-[1px] flex flex-row h-8 cursor-pointer gap-2  items-center px-3 py-2"
          >
            <Icon name="search" size={20} className="text-content_primary" />
            <span className="body_m text-content_quaternary">
              {I18n.t("Search")}
            </span>
          </div>
        )}

        <div className="flex items-center justify-end">
          {rightChildren}
          {showMenuButton && (
            <div
              data-openreplay-label="mainHeader · MainHeader · div"
              className={cn(
                "cursor-pointer flex md:hidden items-center justify-center",
                type === "extension" && "hidden",
              )}
              onClick={() => {
                setIsOpen(true);
                HomeStore.isOpen = true;
              }}
            >
              <Icon
                name="more"
                size={24}
                color={ospThemes.colors.content_primary}
              />
            </div>
          )}
        </div>
        <MenuModal isOpen={isOpen} onCancel={onCancel} />
      </div>
      {/* h5 头部固定在页面顶部，此为占位元素，避免内容被遮挡，在组件内部解决问题，不占用外部布局空间 */}
      <div
        className={cn("block h-13 !md:hidden", slotContainerclassName)}
      ></div>
    </>
  );
};
export const MainHeader = (
  props: BasicMainHeaderProps & { isMobileBack?: boolean },
) => {
  const isMobile = deviceDetector.isMobile();
  return (
    <BasicMainHeader
      {...props}
      isBack={props.isMobileBack ? isMobile : props.isBack}
    />
  );
};
